const CAP46 ={
  "id": 213,
  "title": "Seguridad de las transacciones en Bitcoin",
  "slug": "seguridad-de-las-transacciones",
  "type": "lesson",
  "category": "bitcoin-basico",
  "level": "basic",
  "preview": "Bitcoin utiliza criptografía avanzada, descentralización y mecanismos de consenso para garantizar que cada transacción sea válida, irreversible y resistente a fraudes.",
  "sections": [
    {
      "heading": "Introducción a la seguridad en Bitcoin",
      "text": [
        "La seguridad de las transacciones es uno de los pilares que ha permitido que Bitcoin funcione sin interrupciones desde su creación en 2009.",
        "Cada pago realizado en la red está protegido por mecanismos criptográficos, reglas matemáticas y un sistema distribuido que valida que los fondos sean legítimos y no hayan sido usados previamente.",
        "A diferencia de los sistemas tradicionales, Bitcoin no depende de un banco o autoridad para verificar movimientos: la propia red realiza estas comprobaciones."
      ]
    },
    {
      "heading": "La función de la criptografía",
      "text": [
        "Bitcoin utiliza criptografía de curva elíptica para firmar transacciones. Solo quien posee la clave privada puede autorizar el movimiento de sus fondos.",
        "Las firmas garantizan que nadie pueda modificar una transacción sin invalidarla y que los fondos siempre estén bajo control del dueño legítimo.",
        "Además, la estructura hash de los bloques crea un historial inalterable: si alguien intentara cambiar un dato, todos los bloques posteriores quedarían invalidados."
      ]
    },
    {
      "heading": "Prevención del doble gasto",
      "text": [
        "El doble gasto es el intento de usar los mismos fondos dos veces. Bitcoin resuelve este problema mediante su red descentralizada.",
        "Cada nodo mantiene una copia de la cadena de bloques y verifica que las monedas usadas en cada transacción no hayan sido gastadas previamente.",
        "Si un usuario intenta enviar los mismos fondos a dos destinatarios, la red solo aceptará la primera transacción válida que se confirme en un bloque."
      ]
    },
    {
      "heading": "Confirmaciones: garantía de validez",
      "text": [
        "Aunque una transacción aparece como enviada al instante, se considera plenamente segura una vez que los mineros la incluyen en un bloque.",
        "Cada bloque añadido después representa una confirmación adicional.",
        "Para pagos cotidianos se suele aceptar 1 confirmación; para montos grandes, se recomiendan entre 3 y 6 confirmaciones para reducir aún más el riesgo de reorganizaciones."
      ]
    },
    {
      "heading": "Resistencia frente a ataques",
      "text": [
        "Bitcoin es resistente a ataques gracias a su descentralización y al poder computacional distribuido entre miles de mineros.",
        "Entre los ataques mitigados por diseño se encuentran:",
        "- Intentos de falsificar transacciones",
        "- Manipulación del historial",
        "- Ataques DDoS basados en spam de transacciones",
        "Solo un atacante con más del 51% del poder total de cómputo podría intentar manipular temporalmente la red, pero esto es extremadamente costoso y poco realista."
      ]
    },
    {
      "heading": "Irreversibilidad: una característica clave",
      "text": [
        "Una vez que una transacción recibe confirmaciones suficientes, no puede revertirse.",
        "Esta irreversibilidad protege a comercios y usuarios frente a fraudes como los típicos ‘chargebacks’ de tarjetas de crédito.",
        "Sin embargo, también implica que los usuarios deben ser cuidadosos al enviar fondos y verificar las direcciones antes de confirmar la operación."
      ]
    },
    {
      "heading": "Buenas prácticas de seguridad para usuarios",
      "list": [
        "Verificar siempre la dirección del destinatario",
        "Evitar copiar y pegar desde apps sospechosas (riesgo de malware cambiando direcciones)",
        "Usar wallets confiables y actualizadas",
        "Hacer copias de seguridad de la semilla (seed phrase)",
        "No compartir nunca la clave privada",
        "Usar confirmaciones adecuadas según el monto enviado"
      ]
    },
    {
      "heading": "Conclusión",
      "text": [
        "La seguridad de las transacciones en Bitcoin combina matemáticas avanzadas, consenso distribuido y un historial inmutable para garantizar un sistema resistente a manipulación.",
        "Estos elementos han permitido que millones de personas y empresas confíen en Bitcoin como un medio de pago seguro a nivel mundial."
      ]
    }
  ]
}


export default CAP46;
